import InfoCard from './InfoCard';

export default function AboutInfoCards({ cards }) {
  return (
    <div className="space-y-4">
      {cards.map((card, index) => (
        <InfoCard key={index} card={card} />
      ))}
    </div>
  );
}